import './transferReportErrorModal.scss';

import WarningIcon from '@assets/images/warning.svg?react';
import { Button } from '@prenetics/prenetics-react-library/lib/Button';
import { Modal } from '@prenetics/prenetics-react-library/lib/Modal';
import { Typography } from '@prenetics/prenetics-react-library/lib/Typography';
import colors from '@theme/colors.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const TransferReportErrorModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
    const { t } = useTranslation();

    return (
        <div className="TransferReportErrorModal">
            <Modal isOpen={isOpen} handleModalOpenClose={closeModal}>
                <div className="TransferReportErrorModal__body">
                    <WarningIcon />
                    <div className="TransferReportErrorModal__title">
                        <Typography text={t('customerDetail.transfer.report.error.modal.title')} weight="black" color={colors.B9} type="h1" />
                    </div>
                    <div className="TransferReportErrorModal__description">
                        <Typography text={t(`customerDetail.transfer.report.error.modal.description`)} weight="regular" color={colors.B9} type="p2" />
                    </div>
                    <Button
                        label={<Typography weight="black" type="h4" color={colors.White} text={t('customers.addTest.error.modal.button.retry')} />}
                        buttonType="primary"
                        backgroundColor={colors.C5}
                        additionalsize="medium"
                        fullWidth
                        onClick={closeModal}
                    />
                </div>
            </Modal>
        </div>
    );
};
